<template>
    <div id="tempcreate-layer">
        <div class="tempcreate-inner-layer auto">
            <div class="tempcreate-content auto">
                <div class="title-top flex-center">
                    <div class="flex-center">
                        <svg-icon icon-class="cross-close" style="cursor: pointer;" width="30" height="30"
                                  @click="closeTitleTop"></svg-icon>
                        <div class="title">新建签名</div>
                    </div>
                    <div class="flex-center">
                        <el-button type="primary" size="small" style="margin-left: 20px;"
                                   @click="templateHandle">确认创建
                        </el-button>
                    </div>
                </div>
                <div class="tempcreate-files">
                    <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="108px"
                             label-position="left" style="margin-top: 20px;">
                        <div class="area-title">
                            <span class="bar"></span>
                            <span class="title">基本信息</span>
                        </div>
                        <div class="padding-20">
                            <el-form-item prop="sealName" label="签名名称" :rules="[
                                { required: true, message: '请填写签名名称', trigger: ['change', 'blur'] },
                                { validator: checkSealName, trigger: 'blur' },
                            ]">
                                <el-input class="contract-title-ipt" size="small" placeholder="请填写签名名称（必填）"
                                          maxlength="10"
                                          v-model="filesForm.sealName" style="width: 320px"
                                          @blur="() => { filesForm.sealName = filesForm.sealName.trim() }"
                                          show-word-limit
                                          clearable></el-input>
                            </el-form-item>
                        </div>
                        <div class="area-title">
                            <span class="bar"></span>
                            <span class="title">制作签名</span>
                        </div>
                        <div class="padding-20">
                            <el-form-item label="制作方式">
                                <el-radio-group v-model="filesForm.makeWay" @change="handleChangeMakeWay"
                                                style="height: 32px;display: flex;align-items: center;">
                                    <el-radio label="system">系统签名</el-radio>
                                    <el-radio label="handWrite">手绘签名</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="样式选择" v-if="filesForm.makeWay === 'system'">
                                <div style="display: flex;align-items: flex-start;">
                                    <div>
                                        <div class="sign-uploader" @click="selectSignType('square')"
                                             :style="{ borderColor: isSelect == 'square' ? '#3F7BF9' : '#D8DAEA' }">
                                            <img :src="base64Arr['squareImgBase64']" alt="" width="70" height="70"
                                                 class="rectimg">
                                        </div>
                                        <div class="imgText">方形章</div>
                                    </div>
                                    <div>
                                        <div class="sign-uploader" @click="selectSignType('rect')"
                                             style="margin-left: 30px;"
                                             :style="{ borderColor: isSelect == 'rect' ? '#3F7BF9' : '#D8DAEA' }">
                                            <img :src="base64Arr['rectangleImgBase64']" alt="" width="80" height="40"
                                                 class="rectimg">
                                        </div>
                                        <div class="imgText" style="margin-left: 30px;">矩形章</div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="印章预览" v-if="filesForm.makeWay === 'system'">
                                <div class="sign-previewer">
                                    <img src="@/assets/images/seal/previewBackground.png"
                                         style="position: absolute;width: 320px;height: 220px;">
                                    <div style="width: 280px;height: 180px;margin-top: 20px;margin-left: 20px;">
                                        <div style="position: absolute;width: 140px;height: 70px;margin-top: 55px;margin-left: 70px; border: 1px dashed #86909C;">
                                            <el-image class="rectimg" title="点击查看大图"
                                                      :src="isSelect == 'square' ? base64Arr['squareImgBase64'] : base64Arr['rectangleImgBase64']"
                                                      :preview-src-list="isSelect == 'square' ? [base64Arr['squareImgBase64']] : [base64Arr['rectangleImgBase64']]"
                                                      :style="{ width: isSelect == 'square' ? '70px' : '140px', height: '70px' }"></el-image>
                                        </div>
                                    </div>

                                </div>
                            </el-form-item>
                            <el-form-item v-else>
                                <div class="handle-sign" v-if="!handwriteOk">
                                    <img class="wexin" src="@/assets/images/sign/phone.png" alt="" width="450"
                                         height="330">
                                    <div style="position: relative;top: 57px;left: 48px">
                                        请使用微信扫描下方二维码，绘制个人签名
                                    </div>
                                    <div style="position: absolute;top: 110px;left: 85px">
                                        <img :src="qrcodeUrl" alt="" style="width: 130px;height: 130px;">
                                    </div>
                                    <div v-if="qrcodeStatus == 'scanned'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                                        <svg-icon iconClass="icon-enable"
                                                  style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                                        <div style="position:absolute;margin-top: 74px;margin-left: 43px;color:green">已扫码</div>
                                    </div>
                                    <div v-if="qrcodeStatus == 'expired'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                                        <svg-icon iconClass="icon-yellow-warn"
                                                  style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                                        <div style="position:absolute;margin-top: 74px;margin-left: 23px;color:#EFB040">二维码已失效</div>
                                    </div>
                                    <el-button plain round size="mini"
                                               style="position: absolute;top: 256px;left: 118px" @click="shuaxinQrcode">
                                        刷新
                                        <i class="el-icon-refresh-right"></i>
                                    </el-button>
                                </div>
                                <div v-else class="handWrite-previewer">
                                    <p>请确认签名</p>
                                    <img src="@/assets/images/seal/previewBackground.png" class="imgBack">
                                    <div class="handWriteBored">
                                        <el-image class="handWriteImg" title="点击查看大图"
                                                  :src="handwritingImgBase64"></el-image>
                                    </div>
                                    <a href="javascript:;">
                                        <div class="chongxie" @click="chongxie">
                                            重写
                                        </div>
                                    </a>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {Loading} from "element-ui"
    import {mapState} from "vuex"
    import {makePersonSealImg, addPersonSeal, handwriteLink, keepAskingHandwrite} from '@/api/common'

    export default {
        computed: {
            ...mapState(["currentSpace", "userInfo", "spaceInfoList"]),
            backUrl() {
                if (this.$route.query.from) {
                    return this.$route.query.from.replace(/\!\!/g, "?");
                } else {
                    return null;
                }
            },
        },
        data() {
            return {
                filesForm: {
                    sealName: '个人签名',
                    sealType: 'person',//只有个人
                    sealWidth: '',
                    sealHeight: '',
                    makeWay: 'system',
                    imgBase64: ''
                },
                base64Arr: [],
                isSelect: 'square',
                filesRules: {},
                qrcodeUrl: '',
                qrcodeId: '',
                handwriteOk: false,
                handwritingImgBase64: undefined,
                qrcodeStatus:undefined,

                // 一下为测试用
                // handwriteOk: true,
                // handwritingImgBase64: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApsAAAF3CAYAAADq/IAAAAAAAXNSR0IArs4c6QAAIABJREFUeF7tnX/sv11d11/eN+DNfaMCpkysQGnBahDM0gatnDSt5R/8iDYTW5ut1MrUcm2a/dEPt5aFlSVtuRZpbhpIK1ezYT8WNJlNklXgwiCnEoZACMRNVjv3/X3D9b0+5/f1ep2fj8/GgO/7XOe8zuP1Ouc8r9e5rnN9mvAHAQhAAAIQgAAEIAABIwKfZlQv1UIAAhCAAAQgAAEIQEAQmwQBBCAAAQhAAAIQgIAZAcSmGVoqhgAEIAABCEAAAhBAbBIDEIAABCAAAQhAAAJmBBCbZmipGAIQgAAEIAABCEAAsUkMQAACEIAABCAAAQiYEUBsmqGlYghAAAIQgAAEIAABxCYxAAEIQAACEIAABCBgRgCxaYaWiiEAAQhAAAIQgAAEEJvEAAQgAAEIQAACEICAGQHEphlaKoYABCAAAQhAAAIQQGwSAxCAAAQgAAEIQAACZgQQm2ZoqRgCEIAABCAAAQhAALFJDEAAAhCAAAQgAAEImBFAbJqhpWIIQAACEIAABCAAAcQmMQABCEAAAhCAAAQgYEYAsWmGloohAAEIQAACEIAABBCbxAAEIAABCEAAAhCAgBkBxKYZWiqGAAQgAAEIQAACEEBsEgMQgAAEIAABCEAAAmYEEJtmaKkYAhCAAAQgAAEIQACxSQxAAAIQgAAEIAABCJgRQGyaoaViCEAAAhCAAAQgAAHEJjEAAQhAAAIQgAAEIGBGALFphpaKIQABCEAAAhCAAAQQm8QABCAAAQhAAAIQgIAZAcSmGVoqhgAEIAABCEAAAhBAbBIDEIAABCAAAQhAAAJmBBCbZmipGAIQgAAEIAABCEAAsUkMQAACEIAABCAAAQiYEUBsmqGlYghAAAIQgAAEIAABxCYxAAEIQAACEIAABCBgRgCxaYaWiiEAAQhAAAIQgAAEEJvEAAQgAAEIQAACEICAGQHEphlaKoYABCAAAQhAAAIQQGwSAxCAAAQgAAEIQAACZgQQm2ZoqRgCEIAABCAAAQhAALFJDEAAAhCAAAQgAAEImBFAbJqhpWIIQAACEIAABCAAAcQmMQABCEAAAhCAAAQgYEYAsWmGloohAAEIQAACEIAABBCbxAAEIAABCEAAAhCAgBkBxKYZWiqGAAQgAAEIQAACEEBsEgMQgAAEIAABCEAAAmYEEJtmaKkYAhCAAAQgAAEIQACxSQxAAAIQgAAEIAABCJgRQGyaoaViCEAAAhCAAAQgAAHEJjEAAQhAAAIQgAAEIGBGALFphpaKIQABCEAAAhCAAAQQm8QABCAAAQhAAAIQgIAZAcSmGVoqhgAEIAABCEAAAhBAbBIDEIAABCAAAQhAAAJmBBCbZmipGAIQgAAEIAABCEAAsUkMQAACEIAABCAAAQiYEUBsmqGlYghAAAIQgAAEIAABxCYxAAEIQAACEIAABCBgRgCxaYaWiiEAAQhAAAIQgAAEEJvEAAQgAAEIQAACEICAGQHEphlaKoYABCAAAQhAAAIQQGwSAxCAAAQgAAEIQAACZgQQm2ZoqRgCEIAABCAAAQhAALFJDEAAAhCAAAQgAAEImBFAbJqhpWIIQAACEIAABCAAAcQmMQABCEAAAhCAAAQgYEYAsWmGloohAAEIQAACEIAABBCbxAAEIAABCEAAAhCAgBkBxKYZWiqGAAQgAAEIQAACEEBsEgMQgAAEIAABCEAAAmYEEJtmaKkYAhCAAAQgAAEIQACxSQxAAAIQgAAEIAABCJgRQGyaoaViCEAAAhCAwPQEXisiXysiD4qIpWb4VRF5wvS06ICXgGXggBwCEIAABCAAgTkIvEtEnnVPVPa2GOHZ2wPK7SM2lYFSHQQgAIEOBP6PiDxwaFd7bv9/h7qP7XToKk0qEvh+Eflqxfq0q3JxR7xpU+1Qn/aE1KELNAkBCEBgGwIfFpFHjLczc2EiBHJJjVdudJF5JoZWGS+GiizCgUW4KAwBCECgKYH/O4iwjHUa0dk0JC43phFTzuduq/v7ROTrLlrksvLuedDU37eLyHemCvH7mAQQm2P6BasgAIH9CLjF283Js87LPGc3dsyWikznz/eIyHMadislPJ09z25oD00pEZh1UlPqPtVAAAIQ6ELg9oyl9Rx8fNbS/e+cDJID4oTJ7a/Uxg+KyNO6UKVRH4EfEpFXZaD5ARF5dUa5FkXefe9lJV9bLjZz47iFrbSRQaB0EsmokiIQgAAEIOAhkMralEJz4rFEQJbWHyr/ARF5aqIytta1aNfX8yMi8rKMy0cSmUdzv01E/nLEfvRLhnNHKYKzRvEEdkAAAqsScNuRV9+ovWUor9ajyTjVLydKn67ZIHVlE8jZMv9hEfkD2TX2K3jMzp+t+BYReU0/02g5lwBiM5cU5SAAAQiUEchZ8EM1ugX2IyLyGWVNdikd6ydrTHuX/DMR+X2RZmfMOsdubH5GRJ7bHjMtlhBgIiihRVkIQAACcQK/IiIPF77k4xZ/J9hm/3qKLwM1o7CZPcZDmcDZffFOEfmNAee4R1SeOLvjVrYfsbmyd+kbBCDQikDJ85hu0f+oiDyllXEN2/EJHbbT2zkglGV+o4i8vJ0ZZi19s4j89UDtj4rIp5u1TMWXCCA2L+HjYghAYHMCqecWj3hmzyzluDrEg7Umh961MqHt8xXZh7K3CM5rMWR29YpBaAaLiiEAAQjcI1DyPOZuR7X4hMBuDHoMFF9MfkJEntTDmAZtur75Hj35QyLyDxu0TxMFBBCbBbAoCgEIbE2g9HnMXQ85/+XAOZusN3bDx2X0fM8srs784x4xvcMOgl0kGdW8eiAaYaNaCEBgEwKlh6+v/Dxmict9WTZEQAnBsrK+bPKPishXllUzZWnfoxtkNwdzJWLT3iHu81q/LvPtVDdhvFVEfru9WbQAAQgECJRskd+qQEjdhekTQC7r+dlEXpDA7ZOl5wI91uoRz3b1gfsaEXnd6QfG42CDrEcAD4bAzJz/feHNOAaKmVuoGAJ3CFz5JjnPIoYDyveG/ipzm5vffc9C7rCmjnhUF9nNwSf2HQZGDxfUZEbOdrpnUR7qYTxtQmADAiVvkftw7Po8Zmlo+ObCGdad0scnSrmsVL7XZ1OPDMluDh5RMwz6wRHeZ17JWXs5/cI/OZQoA4E8AlfHJ1nMPM7HUqNnNxGV5T6NXdEzc+27gXyliLxBt4vUVkMAMVNDzX9NTjbTDcR/KSJfcajitSLyRwPPdPYcuHpkqAkC/Qi4w9PdDkHNXOfG38dE5JF+5i/Rsu/ZzRp/XIGxi6i8mnHX4NTat7e48GU3r/K4EnNceyDQKyhWc0LogNlbP3O3xEeYlFfzDf3Zk0DOzd+ZzIjPoq3gPZ8vrESAhljSZh5aHx640JCvTstPNjofur8czZBT5kLXo5f6zt4ku2lFu6DenkFRYOawRVMvAZVOqBwXMqyrMWwCAi4LWfqcM7sHbRyrfSPdWlSOdCMSupFqtZ6nbuRa2eGL3FeIyOtPP5Suw21GxGat9AyK2VHHBtyVBcw3Kbtv2rpv2/IHAQjcJVAqMt0YczeKDwOzGQHffJlzDNLOojLkHG3hXhIEqeeer6x9JXbEypLd1CKpWA9isw5mTGhefYnAly3lzqzOT1y1NoFSkck46hsPMZGEqMzzTe/dr9gjY7mPi+X1tL4U2c16dmZXIjbL0Kbu6rQG23lAj3C3WEaK0hCwI1AiMq/e/Nn1Yr+aU9uvFkRG2v6+2r/Qt8BbreMh/2mte1f5HK8nu6lJU6GuVkGqYGr3KlITpSbLntsk3UFjAAQCBEpEptsheDIkhyBw5dD83A6sJCpDffatCz92Ot0kl1dpud7PiZbaS3azlJhxeU2BZGxqt+pT2UyLrOOsByF3c1KjhlOxkGPGbcFw//2vReSlORdtXib1It4RDyKzb7DcvqxjtbbsICp9Huy5fR4SmqM/luLLblrFZd9RN0HrgI87KZXNtBpsPlHzJ0XkeyaIqRVNTMXB1T5b3LBctWmE6xGZI3ghboNV1nJXUemj/SYR+TLPDy3W79DcN8Oc5ctu/oyIPHf8YbWehS2CdUZqqQyW9UDzDRLrNmf0k6XNqRiwaBsfP04VkWkRXdfrtMxashaF/eMTfB8Qkadfd2m0hpmF5q1j568K8Qy3cdCEqmeA3yWTymJZZTPPlvDcZp9BkfJ/C6tGfOC+Rb8RmS0o57dRcpB3bq23ee289rSaV3PtHKVcr6zmCkLT+fC/iMjzTs5E93SIbqB/Cnoqk9U66+T7zuuuIqTF0CgRmTmx4BaJLz18caN0rOW00YJLizZKRCZjwMYjFkcPxbbCuZnO86NvXvpx42e9VxGaN8LnWGMrPS/2VEuVLoCqjQ9UWezsMGdmr7tujkBqFySpGLCIgxyRtbLozOn/LQIQmbpjwSprmfsJRl6CTPuzR1ZzNaF5m7ePcclWejr21EsgNkWsvgSk4SwmZA2KeXWExGYLsZeTVV1JbCEy82JSq1TrrGWO3e/3PHPIenQ/udZZzdC4bDEH5sRMbRm20mvJKV63++COLfK9splH9/oGP3dligPgUNX5sYUe/k9lV2ef9BGZNrF7rjXn5qXEkltc5mYtc+s+xztz26fI+bKa1uPfN/9Yt5kbK1fLsZV+leDF63cWmz0zWSVu49mmElrzl80RZLON25w+sV1eF7sjZi1ze8JjQmFSref9nud45sbLlXK8lX6FnsK1sy1aCl1+rIpZhKazla10La/PVU8qOzXLtnqqH4jMsrjM5Zlbq1XWMqd9xKaf0gdF5LNOP1lnGFuL25z40Czj20p/iYi8RbMR6goT2FFsxrYqR+VxtrnHFi/jqA+BmLgYXXCmHgtwREfvQx+vP96qxYHpziePishDPTt2r+3VBU4t4tZcVs9q3vxw5uo+f/twrZO4rozAqOKqrBd5pVNbeSOzIAOQ5+NVS/mOwbr1dcTn3FLHiCEy/ZFqkbV0c8eDgw4Mdm3uOqZ1VjO0Lo68HtaG84dF5Cmni79BRL63tkKuyyewYkD5eh9brK23J/K9ES7Z+k5Xw2bq0CUQE3AjxXBKMJHJfDwuLL7GM1LWMif6EZt3KbWe630+WHmM8lJazsg0KLOD2IwtfiNmhXxuZlI2CP4Jq4xl50cQnLFt81nGmlVYaG+JO9YjZy1zOPqSADusSSE2rbOazo7W4jYnLizL+J7dfKOIvNyyUeoWWX1gz/y82zE+mZQZrUcCoz13nHpEZeVMyc0vt0PS3f+3mFdny1rmjFjmtfsptRZ+u2U1j2P1OEZHuFHPGS9Tl7GYFEcCElqUZ+u3bwt1tj6MFBcr2BK7kWoZG7FHVKyEV2//aWcpz/1ZIWuZ4yPE5qcokdXMiRidMj8iIi87VfVOzzfUdVqjlscItFyUeiBvfado2UfeSLekO2fdPTP3qZeAVsoWtBCXo7wh3noknOe11dekEN/Wa5Vv7tjplBMSOI1H+uoD+zigZl/8eCO98eCYpLlYZtFi+zr1ApDDNvui1UJcan+NZ5JwvWMmYlOErGb76P16Efk7p2Y/JCJPbW/KHi2uLjZX8mLrO9+V2K3el5jg1BB+qSzmke+Mc4qFuDyOV4RleATydnD7l3R843n2ZEzNHP8RzzmbM85fNX1vfg1gmyOvbpA30qvRbXFh7CWd2jfBc7KYN7gzLVZaxw7t8myl5QDafceGrKZldMXrfrGIvPlUBE1k5A/AGoE1qJaH6Q2gLlalxtFIqRd+zshmEZml/fKFBuJSf8DsLjZb71j55ohZxrB+9N3NKqOJLChv8IKQEbYu1fJAcxfsUzYaOoUhtKjUZPo0tuct4db0ySekZz/L0pKxRt2txZaGzVp19PhMJDtk93vvHH/fJyJ/RMvB1PMpAqj4uaLhPDCeJSL/fa4uYG0jAjmCs2Sb3Jk9egbkavaSzGWj4Dw0s7P46SG0d88k+24oz/+G4DSYBxCbBlANqzxPFK8UkTcYtkfVcxMoFZOh3o6SxbQ4OL32eda5I2Mc63cVmz2ymrcbxqP3LU6sGCe60pa8XkRe4Sn2t0TkG9OXUyKXAGIzl9QY5Thrcww/zGRFreC0zmK6x0KOb2m3motcv3Y903LEuN31WfQeWc1dWafi/u+JyNeeClnPfymblvu91QS/HLhOHWILpBP4iZutFZsTd/mO6WQvx/XmjgKoV1ZzR9a5ke8TnOijXHoZ5YCZAWmgIojNgZwxiSmhZzcnMb/KTLKXVdi6XLSjAOqR1XTO3fWRhdzA/lkR+YJ7hd99+N+511MuQgCxOVd4IDbn8tcI1q4sNo994+D0EaKtzoZzjK68LvXKaiI207Hpvpf+mnun9HyTiLwxfQklcgmsPKhzGcxUDrE5k7fGsHXGbfRjnDv7nzAGSqwwIrCT2OyV1XSuY/0wCmCqTRNAbKYZjVSCyWIkb8xri8XXhualgeW9CZzntVWfse2Z1URs9o7yzdtHbM4VADxzM5e/Rrc25yzO0fuAffMTmPEmWmvHoOUaPCPn+aObHjxGoGWgg/w6AcTmdYbUcD+BkOBcNbuE/8cjMJMI8n3J7QrRludc7vS4whWfcK0BAcSmAVTDKhGbhnA3rjqUpWm5EG6Mf/uu93yOsQS+VjbT12aLcx0RmyXepqwqAcSmKk7zyhCb5oi3bSC0kDJHbBsSzTo+w7x29VOouTAtRSdiM9cLlFMnwEKijtS0whkmZVMAVG5KILSlzjxhin37ykef12Iv1OV8yrX0+LGcOmuCBrFZQ41rVAiwiKhgbFbJjgcgN4NLQ48R8C2MltkWsENg9HntypjwCenbv8XWX4u1GbHJWOtGwCKgu3Vmg4ZHn5Q3cMHyXQy9AGGVbVkeKB1MEhh5Xrua7U89jxranre4wUNsJkORAlYEEJtWZG3qHXlStukxtfYgwPObPajv2+ao89rVceC7/kMi8lSPq32iVPsGD7G57xjr3nPEZncXFBkw6qRc1AkKT0Hg6kI7RScxchgCowmhUEaz5ISGVFbzCD+0o6C5Ro/GeJjgwxB7ApqBbG8tLfgmJHxIXDgCOceylG7NXXlWDa9AoITAKEJI6+taJVnNGyfrLwyNwrgkLii7CAGEylyOfJWI/NDJZHw4lw8trM0Rmsd2f0FEPj/DkNDCW5LdyWiGIhC482Jaj48KxISmxo1azlztu8HTYoHYZKB1I5AT/N2Mo+E7BL5ARH4WsUlkHAiUCs3bpbmLZ+gFBuYOwlCTQO+vCMXO0SwVezVZzRvL0HZ6qQ0+3yA2NSOWuooIsGAU4RqiMBPGEG4YwohaoXkz/mMi8nBGT6y39zJMoMjiBHqKzdg4qnlJp+RZTZ9bQ/bU2HKsn7Vj8UE0cvcQmyN7x28bE8Z8PrOwOLQg+TKWPy8izwwYkSs4fQso2+kWnt2zzqsCrZZabOu8Jr594/LHReSlhQZafEKWtaPQCRTXI4DY1GPZqiYmjFakx22nRGgeexG67gdE5NWJ7rKdPm48rGBZr68IXT1H88j+TSLyZR5n1K6zGm/Ek9lcYXQs0IfaQbBA16ftAmJzWtepGF4rNG+NXxGcli8vqMChkmkJ9BCb2o+HaGU1YwLx9lvN2t3zUYVpAxPDdQjUBKxOy9RSSwCxWUtu/uveLCIv9nQj92Wf26W12ZzQliPzyPyx1bsHPc4Q1ty6185qWghOxGbvKN+4fRaJ+ZyP2JzPZ1oWa2ZiagWnpg1aXKhnfgKtxaZ2HFtkNW9ejT1XWrKGIzbnHyfT9qAkUKft5GKGIzYXc2hmd0JZzdox/P0i8tWVWVLNjFBm95cs5kTEk+71rNSPGkfhjAS1pdjUztD/GxH5nR6YpT6N+SNkc8muBmJzpIjfzBbNwbAZum7dRWx2Q9+1YV/m5C0i8pILVtUKTt9ZgCWL3gWTp73UMXtARCzm3KtH4owCtdXcpn2ygq++mjfQU34IvaSXO/YQmynC/G5GwGLiMzOWih8j0GpCBvc4BLSzmseefVREnuzpqvt4wHMiCMhuhuFYCstYVDqfuJuSJ4wTukWWtJjbtLfPfQIwV/wVwblXOCQ4c45p6vESVk0fuWZBAojN+ZzaYkKej8raFltkNXMEZ2x+8GU3V9vazY2q23b4SPOpmyceFZGHcjsxQLkWc5v2TZJ2fTluCJ0okYo/xGYOXcqYEEgFp0mjVHqJQIsJ+ZKBXKxKwDKreTS0JuPTY6FVhXuhMovs5Y1nTCTWfDXKMtN2AeGdS63ntpoYj/VPu74SljVtIzZLCFNWlQBiUxVnk8qsJ+QmnaCRbALWWc2jIT7xGNtO99mWs52X3fnBCsa+n11iqsZ2d002dXTRaTm3zfhSUCqmSm/2EJspovxuRgCxaYbWrGLLCdnMaCquItAqq3kz7l0i8oUeS2PzxOovHcSOnclxqoawTLVTmmUd9YbAcm7TvjHy1fdhEfnMlLMUfy/NbrZ841+xm1S1AgHE5nxetJyQ56Mxh8UvE5HX3HsT+ZtE5I2ZZrfMat5MKl3AVs2W1IrM3tlD37O0vnAb8flay7mtNAsYG6L/S0Q+o/CmLHPIFxfz9St0M4HYLMbLBVoEEJtaJNvVYzkht+vFXi19QESeeujyi0TkbQkErbOaR3N8C9jfFZGv89jsE2W9BdeV6CoVmS0yl7X9ydn2H2kNsJrbfDdEV46L8o2Pfysiv6vWUReuK3k8ALF5ATSXXiMw0kRzrSf7XG01Ie9DsH1Pz2LzQyLypQnB2SOreSNTup2umTVq753HWywRmbO96Z0SnaNsq1vNbZrxWZr5bxHPuTYhNlt4gza8BBCb8wWG1YQ8H4l5LP7DIvL3T+Y6wflCEXl3oBuaC2QNKd8C9k4ReZ6nMt8idiVzVGNv7TUlInMUUVbbV19M3eoaIRttMbf5YvPKIwS9x2XI97l2WTCujUeu24gAYnM+Z58ni6eLiMuc8Tc2AZ/g/I/3MpwfPJneM6t5NCV3AXPXlJQdwVM7icwj79TRST3XBAshpBmXPnZXhKvmOMjNblow1uwHdS1KoOfEsihS826dJ4uc5//MjaKBLAIuu+lE5/HPJzg1F8gswwKFSt649ZX9DhH5S1cMMLo2Jbhuzc6eyQzhSwntXgJKWwhpfla1xffPr4Z7zryhzfiqzVy/CQHE5nyOPk8WXykiPzpfN7a12Cc4/4mIuDfW3d9HROThEx33SclHOhHLWcCcaa8VkT92srGXaImhyhGaq4rMM5fRttW1hZDmSQkjvRRUchNxfjxCm3GnaYlmZyOA2JzNY3e3K0d41mo+in0t/lf3ts+PVvyDe1nPXHHXqgef8Hxr22WMnugxYDTbS8SVK7uLyDxySb081HKN0BRCmqcktP7++ZWxnRqDmoyv2Mm1mxFoOZFshtasu+fJArFphtqsYncMkhOc7gWh49/fEJE/dfq3EfybWsBuJmtmkrThx7J4O4rMI9/UtnqrdUJTCGke4p4b/9oxW1OfTxgf41uTcY19XLMpgVaTyKZ4TbqN2DTB2rzSkOA8GzLCGPUdYu0TwT7R0lvIxYTUiNv8zQPx0GDsEYMWftQUQloCMffFm55+S2Xwj2NVk/FIfcaWwQmMsJANjmg48xCbw7mk2iCX2XQZzuOB7yOKTWdT7uI9UnwiNMtDM7atbi3OtYSQ1iHuM7wU5PNwbIdBi3F5ZHHF1gQQm/O5f6TFvDe9nJc9jjaOsCV9ZhYTnB/zvCzUi/k7ROS5nsbPc0iuKLXuR0w0tcjSWffPsv5eglNLCGnFYMlpDJb+KK3bd5N1u1HQYlxqE+U3J4DYnC8AdhebpQLz7OERDxt3XxNyGc7zn3sR51tF5LsHCdOcZzJH+EoJQvN6wMSywlY3bRpCSOsQ95G+f17jzZDg1mBcYw/XbE4AsTlfAOQs+PP1Km7xVYF5rn3EuI+9wOK285wg7f3nO97oLDzcIwHnjwy0FPixWBnR7719mmo/FpfaPDWEkFZW01dPr++fp3zk+z20TmgwrrGHazYnoD1ZbI6zSfd3EpvaIvPmIKvMTG0A5PTTbal/uYj8u9pGlK7LWcx7ZN99B3gfu8xcVx8ArQTnVSGkdYj7jC8F+bzrG4fnccC4qB8XXFlAgEArgDVI0R3EZo74OrojJR59i2XLbFsqdGKL+fnat4vIC1IVGv7uspbnF5r+5unIphxBqmliLF5SsaFpx8p1tXhT/arY1JobW8evVdzkzCuMDyv61HsfAcTmfAGhNaGO2HP3pZwnZxpWMkmGsl4jxH/oi0HfLiJ/1XOgusPj+vNVIvKPM1lpF0tlLlvFaCqbWRIj2oxWrM/6xaErYlPrEHdf7Fq/hW8VK6kD+127jBEr+tSL2Jw8Blot5K0x5WQzr0yMo26NxbIozxKRfy8inxdwxntE5NmtHSUiqRhs8ZJQKl5Gylx3cJFZk5aC84rY9MVD6akDbxaRF3vIjXBTWuvQVHbzypxaaxPXbUhg5kG0obse63JqoZ+Ri3se8aGI4VpHAI24nZ7KEjosofP+bvHwbSLyVxo63n3p6BtP7X1QRJ527998GUetuSYlMlk87QPB6k31K2JTY+vbF1szvRTk83xqvLhrtMamfeTRwrQECLL5XNcia9SaSmhC1BYOo22nl/jy94vIDwa21Z2/Wmc5U4v7+ffSLNM5BlOfVHTlyWa2HbmhrFmtH2rFpm/+qLEhFdNt6eq0ljNu0AE6rKklQoAgmy88SgTKDL0LZTWtYnOk7fSaLPXrReQVEcf+bRH5Ew0cn4rDnIxtrpmp7Iz2TUmuXZTzf1mqNltWKzY1RKIvxtzz1E9ZwMmprXSruXYBdHRBiwBBpkWyXT2pRb6dJTot+SZ5dzee+6JQjRUai1NNu+dragXZ80XkrZFHD35JRF4qIu7Ndcu/mP21fTvbmxKaVzOmlnx2qVvrBq5GbGod4j7KnGARM6kxhA6woE6d9xEgyOYLiJXEZuhlA+u41Dpl91ODAAAezklEQVSP70r0/KSIfNGpgv8gIr+1oFKX5Xx55Jkr6yxnbIHWWLw50qggGDoX1XgeukZsWsXZKlnNW1jEspvW823n0KT5EQgQZCN4ocyGVcRm6Fki66xmbPJtOR5qttB9keKynG8Skc8JhJHL/P02oyxn7MzNq/1r9Rxv2eijdIiAxvPQpWJT66ZRQ7COHhmIzdE9tLh9LRfXxVE2655PpM3mx5DQbPns3VUxdNXh2gvc94jIN0SynG8QkVdeNdpzfWi7/MpNEULTwFENqry6nV4qNjXG8K+IyCMnNi3noQZueawJyyOrWvWBdiYmMJtImRi1mukvFJGfOtU2mx9Dd9mt+6H1XGGNc89taxwc7bKc/1RE3Pmcvj+X5Xy18mHwoQXfd0PxzSLy3QlYCM2aaBrnmivb6SViU+sQd+2bvnE8cdeS0Ly7orge2Q9b2tZ6cd8SsnKnny4i759YbIbERI9Y7LXQXMn65YTTnxWR7xSRBwKFf1FEnplTUUaZ2JmbpWI+tBXLYpjhiEGKXNlOLxGbVoe4rxxr3MgNMkh2NKPHAr8jZ+0+W2TFtG301Rea7Hq9UayxDVfDrVW7745kOV0M/XER+d6aDpyuCYn2UjHvK7/y4q+AfsgqarfTS8RmaWzlzkcrr4mxMzdX7veQg2Q3owiwOT1emjEaoZehjEfN4cua/enBsmWbqcPgNbKcoUytT3R8q4h8l8eBtQJFMxaoS49AzXZ6rtjkEPd6P43yCFN9D7hySgKIzSndNuUnK32TnMZzilc9qJEhKbFB48ijkvZuZX9ORH5t4EKNLOeZ4/8UkdeJyLd4sqDH7f3QTYi7jPmpxtNjXFOznZ4rNjXGrE+wvkVEXjIGPjMrRnqMyayTVDweASbz8XySY5H1M385NpSUGTlr1WpL+8ardXtHP329iLizN0Pj/kqWM5StjQmD2DmavTPeJfFNWT+B0nGfIzY5xP16tGmI9etWUMNWBBCbc7rbvdzx8yfTR12cazIcrb1ynnx/WUQ+28iIESb6XxCRz1POcoZEdEhwxDKXPKdpFHwdqvXFu+8Zbd884VufNMaPLyZXO8Q95moNhh1CiSZnJoDYnNd7LZ/7u0Kp5tmtK+3VXNuS5bmtXo8SpLKcTpB+fgFM94nMX3Mq7+aXfyQiX1VQz6g3TQVdoOiBQO7NZk7Gn0PcdULLlx3u9ZKmTo+oZXgCiM3hXRQ0MGdy7t270m20Xva2EpsjPv4Qy3KWLkC+5zbdl41i2+U3n5PN7BX99u3mvNCTM5/llEn1ZpdD3FMcWs15KTv4fRMCiM15HT2icDnSDB2zMWLMaSxiOZE06vZVLMvp2PxeEfmxjA7GFrDQW7CuWoRmBtzJi6RiP0f85JRJYUrZkbp+ld/hsIonJ+nHiAv/JOi6m+kTc6WZKMtO5GQzLNsvqbuX2BxNZPm+dX7j+BUZgjPGkQOlSyJyvbKpXY7U4yUa892bReTFJ7SjjcFWnveJzV6P9LTqM+10JIDY7AhfoWmNO30FM+5UMVNW0xnfIkvsa+NtIvIiCwdcqDP2jOUPisgfjNTte27TLfC/44I9XLoOgVA27X0i4h63OP6d1yaNMdrqpnIGj3EE0gxeWshGxObczhx1K8Q3kY2UdT17XWMhS0XSTAvdnxORvxjokLuReHKks6PGZMo//G5PIJTd9GUXz2uTxvgZ9ebcnvzdFmZLCPRgRJuKBBCbijA7VKUxAWubPeskdl6ItMfGbAvdl4vIv4icyel+c89ynv/ImGiPqLXq892MuH87jzdtsemLyx0OcY9FT8gXx48urBV99KYbAe0FtVtHNm3YJ+x+i4j8dEces2U1b6jOE6/mWZsfE5GHTj5JZQg7uvC+pj8hIk8IGBM6psi3iH1URB4ZpVPY0Y1A7ItRx7F4FjxXb9bIuHNj2C3oaZjPwa0QA1cnYU0GuWfqabapVZclxxEz0CXcPiginxW54O0i8oLD739BRL7DU95tzf/5koYpuySB1FFYvm31K+Nz90PcQ0Hke3zIlR35kaclB8QOnSKzOb+XR7pj99kyy8R1ZTFLRZFl3am2tX7/LhH505HK3IL+KhF5w70y7ossD3vKM+doeWTeekKP2tx65F40+9xT985jqGReGWmOHM1rbKWP5pFF7WHin9+xo2TNUkebjE7aiuNPicgLT52f+YgR95lU97nU0N/xy0Ozx8ToMTuzfbHs5nld8onT3LWLQ9zjUeITm+6KXL4zxyC2NyRAQDWEbdSUb+vafff6vUbt+aqd9aWgY1+sxKZVvQ3de6epV4jID4tI7EWCvyYif+bege3nCph3enpvnLZzhc6V0yLIasb9HRL9M98QjxPhWPJJAkz6awRD721a34Q+2zeuryxosShaebFzL6I9P9J591KQy+y+ZKHM7hozxhi9yD25oPaGjaxm2s+xRxrQB2l+lMgkQDBlghq8WE+xucpWaSux6Xv5YfDwSpqX84Yx2c0kxi0L5NyM1YrN2ut2c0Ruhnk3LvRXkQBiUxFmx6p6Tqo5i0VHNEVNW5y1aVFnUacaFf7nIvJ7Ctp6k4j87oLyFF2TQI7QqbmZ/gkR+eITshVv9DSiIpRhhpcGXep4jABic41AsMrKpeisktW89fO8qF19FMC3zbz6mHtURJ6YCpx7v6/OIhPDtsViGfFjbNSITQ5xzw+r0BFIaIR8hpRMEGCyXyNEPlNEPnTqytNExJ2PaPW3wktBZzY1i1qMb6+bACuf59brvof+4ozCzD8ZkBYuEnsj/ZhVKz32yJfVRDjFAymUYS45YmrhUKVrVwkw2V8lOM712lm5VM9m/VJQrF+IzZTX83//GhF5HTe7+cA2LJk63N2tTzXHHvmE01tF5Es2ZJzb5ZDYZCs9lyDlogQQm+sEiLZQipFZMavp+qv97Ouumc1j7LjMyJMCwcT8s878U9OTkMC51eVixz2ScT5iKxY3vo8JIJjS3on5gnGa5kcJMgvbxEBLsbliVtNCbGqL15mD+cMi8pRDB2b5NvzMzEe3PSU2b7+fxU5M/Kz0wmJL/8WyzGylt/TEom1xx7KOY1uJzVWzmi4StDORiM11xhc90SXwPhH5nIwq3byWKzbJamYADRSJvSREZrieK1feI4DYXCcUWgmbVbOaLhJ8b8deGSOtfLJOFNOTXQj4xI37twcTAGLCh6xmffSkzsq9Mg/WW8WVyxAggJZxpfrzhiEyq0/omuditso2rxPF9GQXAqEbsZytdd9nUlc7hq1HHMTYXz0Grkd/aHMgAojNgZxx0ZQWWTTfFvpqz/OcJ9wr3whGbF4Mai5flkBobKTeUA/NN6vfBLcIhJjYZCu9hQcWbgOxuY5ztZ839JFp0UZvj2gKRM26enOhfQhoEgiNjZrtXLKaOp5JZZXRCzqct6yF4FnH7S2EYIvsaW+PaApEzbp6c6F9CGgSOI+NXxKRz73XQOkxPGQ1dTyTyipf2eXRsZBapiWA2JzWdXcM1365xUdmB7Gp2cfzIvh2EXnBOiFHTyBQRSB1YxwTPec1y1f2oyLySJVle18UeyP9RgbNsHeMVPeewKlGN9yF7hgRd5zI8U/bvztk6izFprY/hgtCDIJABoHUGAsdr+aqPo8hspoZwDOLpB5h8PHPrJpiuxNg8VsrAs4Tr/YbhDuIzVTWpSRiNN9sL2mXshAYmUCOQAxtpR/XLLKa+l5OPbfJVro+8y1qRGyu5WZLMbjDm+guGt4vIk9XyhAjNtcaX/RGh0DOPBXaSr+tWT8hIl/sMYc17ZqPUs9tkt28xnfbqxmYa7k+tT11pbc52Ygr9Y90rYZI1MyQjsQGWyBwlUDuDkxszvHNdW8VkS+5atzm18ceYbihQTdsHiQ13SdoaqiNe42V2NztaJGczEsqChCbKUL8viOBkhcZQ2LzJ0Xki8hqmoVPKrvJmZtm6NetGLG5lm9LJvKSnu+U1XRcEJsl0UFZCOQTKLkhDpUlq5nPu7Zk6tlNtEMt2U2vI2DWc3zuFlVuz3fLavrEpvu30rFCZjM3wii3E4ESsekTPB8TkSeT1TQPmVR2c7Uvx5kD3b2B0gV0d14z9F8jK3frZ+gojNXjpmRBDMWERh0zxBs2QqCEQMn8lMqu3dpdfT4q4atZNsafrXRN0hvUxSBdz8maIsc32exwR6vBUKOO9aKTHu1O4DynxI7SyRGbiB67iEplN9EPduyXq5lgWc6loiVydtw+v0WDxha4lh/Wi1B6tCuB/3H4JGVOVjJHbLKG2UZTzAfa5zjb9oTauxJgoHbFb9K4xktCoeMvdokXjbM2EZsm4U2lExMovYlLiU2ymvbBEMtuwt+e/zIt7CIelnFYZkeuviTkm+R3+3LE1bM2S55Ny3QrxSAwNYHSG7CU2GT9ahMOMT/ggzY+mL4VAmV6F3o7cEXo+LIPrpHdYgWxuebYoFf9CJTOSzGRs9vNbz+vicS+mY4fenpmorZ3ExATueaSqVfOxdz1paAz8JIXGXzOKl1YLzmciyEwAYHSMUFGbRyn4otxfDGlJYjNKd2WNLp0u+pW4c4vBaXEZunzSaULa9KpFIDA5ARKdwsQOOM4PJbdREeM46dhLSFIhnXNJcNKH8SPfQ931xi5KhavXn8pALgYAoMRKJ2TnPmIzbGcGHpZqPRGfKxeYU0TArsKiSZwOzbiuwsNnY8ZekbTmb/z0RZXxWJpFqdjuNA0BMwJ1Oy2IDbN3VLUAEmJIlwUPhJAbK4bDznPbXKsRdj/iM11xwY9a08gZz46WvVTIvLCiJk7fFyivZfSLYbWDPyRZrd1CcTmuu6PZRJid6iOCG8YPs7gPD5yx8s7ROS5p9DKvXbdiKRnOxMovXlLfb2Grdt+0eS7ccAf/fwxRcssgFO4qcpIn6B0/o5tm7uGuEN9HPcVsVnzfFqVk7kIApMQOAuU2CM6qazmrcusX32cH3pZCH/08ccUrRIcU7ip2sjUocjHirkzvR/zFbF55dpqZ3MhBAYlUHrzlcpqIjb7O5qTS/r7YCoLEJtTuavY2Fyxybb5XbRXBOOVa4udzAUQGJxAyXjIzWq6LrN+9XU8ZzL35T9V6wzWqdxVbGyO2GTb3I+1ZIE811D6MkSxY7kAAhMRKBlLuVlNxGb/AAj5Cl3R3zfDWUBQDOcSVYNiYpNt8zjq0q2/Y22lL0OoOp3KIDAYgdzxUJLVdF1kDuvr6NCLpvilr1+GbB2xOaRb1Iw633m6ScD950G1FtatSFNs8pjCunFCz9IEzmIzNB5KspqIzTT3FiVCCQ20RQv6E7VBQEzkLExtSkBTbDLOmrqOxgYi4Htz2TceSrOaiM0xnBy7QWDeG8NHQ1hBMAzhBowYkECt2HxURJ546g/jbEAHY1ITArnjKCer6bJotWffNunspo2Espvs6GwaEL5uswgSDBAIE6j55GTu4gp3COxAIOfloNysJmJzzIghuzmmX4ayCrE5lDswZjACNWIzZ3EdrJuYAwEzAjkvB/nGzNs8n6t05R5g18DMV1cq5jv2V+htcC1icwMn08VqAojNanRcCIHHCKTEZiir6dYm34tFiM0xAyuW3Yx9LWrM3mCVOgHEpjpSKlyIQI3YTC2uC+GhKxBIEkiNoVBW80UesekToKxhSRc0K0B2sxnq+RpioM7nMyxuRyD3yJajRYjNdv6hpbEJpJ5fjmU1fVlRxObY/o5lNzl7c2zfmVuH2DRHTAMTE6gRjudrPiEiT5qYAaZDoJZA6vnlWFYTsVlLve91ZDf78h+2dcTmsK7BsAEIaIhNxtgAjsSELgRin21NZTV9YpO30bu4sahR37mqtwrIbhahXKswC+Fa/qQ3ugRKxWZq21DXOmqDwNgEYuMnldX0iU1fb1nDxosBspvj+aS7RQzU7i7AgIEJIDYHdg6mDU/gPH7eJyLPEJGfFpHne6w/r0c5B72zho0XBqFvpt9uIM4nCozXAyxSJ8BAVUdKhQsRSD1zdu5qafmFUNEVCNxHIJblz8lq3iqLZclcGdawMQOPg97H9Es3qxio3dDT8AQESsVjafkJEGAiBKoIhMZCblYTsVmFfaiLQjcKnLs5lJvaGIPYbMOZVuYkUCoeS7fd56SC1RBIEwi9HOT797eLyAsCVZLZTLMetURsOx3tMarXjOzC4UZgqXYJAojNJdxIJzoQ8N14PSoin36yJfWGMmKzg/MUm/Q9TuGq/7iIPKTYDlUNTgCxObiDMK8rgati850i8ryuPaBxCPQhcBaJTnQ86DEltQYhNvv4T7PV0PObKd9r2kBdnQng7M4OoPmhCZQeZZT6NN/QncU4CCgR8I0bl8kqzWo6c1JvpLOGKTnNsJrQdjq+M4Q+WtU4ezSPYM9IBBCbI3kDW2YhkBKIt37krj+82TyL58N2xg74n7939CBJIHewJyuiAAQWJFAiNkvKLoiKLkHgkwRSW9+uYOpZzTNOn+AsrQMX9SNw9h++6+eLLi0jNrtgp9FJCJQIyJKyk3QfMyFQRSBHbLL2VKHlIgjMSYABP6ffsLodgdznMBGb7XxCS+MSCL19fLSYrNa4/sMyCJgQQGyaYKXShQggNhdyJl0xJ5DzvCbrjrkbaAACYxFg0I/lD6wZj0Cu2Cw9Jmm8nmIRBK4TSG2hk9W8zpgaIDAdAcTmdC7D4MYEzounE5W+8wIRm40dQ3NDEkiJTdacId2GURCwJcDAt+VL7fMTyP0EJWJzfl/Tg2sEUs9rhm7UrrXK1RCAwPAEEJvDuwgDOxNAbHZ2AM1PQyD1vCbrzTSuxFAI6BJg8OvypLb1COQeRpwrStcjRI8g8DiB2BY638ImSiCwMQHE5sbOp+tZBHK3xxGbWTgptDCBmNhkrVnY8XQNAikCTAApQvy+OwHE5u4RQP9zCMS20Mlq5hCkDAQWJoDYXNi5dE2FQO5h7WQ2VXBTyaQEyGpO6jjMhkALAojNFpRpY2YCiM2ZvYftrQiExObbReQFrYygHQhAYEwCiM0x/YJV4xCoFZuMrXF8iCW2BN4rIs8INME4sGVP7RCYggATwRRuwsjOBHK+IpRTpnM3aB4CJgRCz2uS1TTBTaUQmI8AYnM+n2FxewI5QjKnTHvLaREC9gRCW+isL/bsaQECUxBgMpjCTRjZmUBKSOZutXfuBs1DwISAT2z+ZxH5zSatUSkEIDAdAcTmdC7D4A4EEJsdoNPkFARCz2uytkzhPoyEQBsCTAhtONPK3ARSYjP3LM65KWA9BO4S8MU+WU0iBQIQuI8AYpOAgECaAGIzzYgSexLI/ZzrnnToNQQg8BgBxCaBAIE0gfOC6rI5Dx4uI7OZZkiJ9Qj44t6NlQfW6yo9ggAErhBAbF6hx7W7EEh9HSj1+y6c6OdeBMhq7uVveguBagKIzWp0XLgRgZSYTP2+ESq6ugmB0NmarCmbBADdhEAJASaGElqU3ZVASkymttl35Ua/1yXA2Zrr+paeQUCdAGJTHSkVLkigVGwyrhYMArr0SQKhrCbPaxIkEICAlwCLIoEBgTQBxGaaESX2IUBWcx9f01MIqBBAbKpgpJLFCcTEJl8PWtz5dO8+AqGspivEekKwQAACZDaJAQhUEkBsVoLjsuUIhLKaiM3lXE2HIKBHgDtRPZbUtC6BmNjkjM11/U7P7icQy2qez56FHQQgAIFPEkBsEgwQSBNAbKYZUWJ9AmQ11/cxPYSACQHEpglWKl2MQExscrD1Ys6mO14CsawmW+gEDQQgECWA2CRAIJAmENsqT72pnq6dEhAYn0Asq8mRR+P7Dwsh0JUAYrMrfhqfhABicxJHYaYJgVRWk+c1TbBTKQTWIYDYXMeX9MSOQInYdEchPcHOFGqGQHMCsaymM4Z1pLlLaBACcxFgkpjLX1jbh0CJ2GRM9fERrdoQ+LiIPClRNTFvw55aIbAMASaJZVxJRwwJhMTmfxWR55zaZUwZOoKqmxNIZTV/UUSe2dwqGoQABKYiwMI4lbswthOBkNjk60GdHEKzTQiQ1WyCmUYgsD4BxOb6PqaH1wkgNq8zpIb5CKSymjyfPJ9PsRgCXQggNrtgp9HJCITEJl8PmsyRmJtNgKxmNioKQgACKQKIzRQhfoeACGKTKNiNQCqrydmau0UE/YXABQKIzQvwuHQbAiGxyYHu24TAVh0lq7mVu+ksBOwJIDbtGdPC/ARCLwIhNuf3LT24S4CsJlEBAQioEkBsquKkskUJIDYXdSzdukOArCZBAQEIqBNAbKojpcIFCeSKzXeJyG9YsP90aR8CqU9T8qzmPrFATyGgRgCxqYaSihYmkCs2GU8LB8EGXftPIvKbEv3kEPcNAoEuQkCbAIujNlHqW5GAT2y6f3vw1FnG04re36dPqaymI0GM7xMP9BQCagSYONRQUtHCBHxi0y3MDyA2F/b6Xl3LyWqyhb5XTNBbCKgRQGyqoaSihQkgNhd2Ll17jABZTQIBAhAwI4DYNENLxQsR8IlNl+U5jx/G00JO36wrqeOO2ELfLCDoLgQ0CbA4atKkrlUJIDZX9Sz9cgTeISLPTaBgC51YgQAEqgkgNqvRceFGBHxi89x9FuONAmKxrubEN2vFYk6nOxBoSYAJpCVt2pqZQGqbEbE5s3f3tp3nNff2P72HgDkBxKY5YhpYhABicxFH0o07BFJi8+dE5NfDDQIQgEAtAcRmLTmu241ASmwylnaLiHX6S2yv40t6AoEhCbBADukWjBqQAAvygE7BJBUCsdgmq6mCmEogsDcBxObe/qf3+QQQm/msKDkXgVhss0bM5UushcCQBJhIhnQLRg1IALE5oFMwSYVAKLbfIyLPVmmBSiAAga0JIDa3dj+dLyCA2CyARdGpCIRim/VhKjdiLATGJcBkMq5vsGwsAojNsfyBNXoEfLH930TkC/WaoCYIQGBnAojNnb1P30sIIDZLaFF2JgLno484M3Ym72ErBCYggNicwEmYOASBmNhkcR7CRRgBAQhAAAIjEkBsjugVbBqRAGJzRK9gEwQgAAEIDE8AsTm8izBwEAIxsem2IR8cxE7MgAAEIAABCAxFALE5lDswZmACnEU4sHMwDQIQgAAExiWA2BzXN1g2FgHE5lj+wBoIQAACEJiEAGJzEkdhZncCiM3uLsAACEAAAhCYkQBic0avYXMPAojNHtRpEwIQgAAEpieA2JzehXSgEQHEZiPQNAMBCEAAAmsRQGyu5U96Y0cAsWnHlpohAAEIQGBhAojNhZ1L11QJIDZVcVIZBCAAAQjsQgCxuYun6edVAojNqwS5HgIQgAAEtiSA2NzS7XS6gsD5+9HHKhhHFUC5BAIQgAAE9iDAIrmHn+nldQLvFZFnBKphHF3nSw0QgAAEILAoARbJRR1Lt0wIhLbSGUcmuKkUAhCAAARWIMAiuYIX6UMrAqGtdMZRKw/QDgQgAAEITEeARXI6l2FwRwK/KiIPeNpnHHV0Ck1DAAIQgMDYBFgkx/YP1o1HwLeVzjgaz09YBAEIQAACgxBgkRzEEZgxDQHE5jSuwlAIQAACEBiBAGJzBC9gw0wEEJszeQtbIQABCECgOwHEZncXYMBkBBCbkzkMcyEAAQhAoC8BxGZf/rQ+HwHE5nw+w2IIQAACEOhIALHZET5NT0kAsTml2zAaAhCAAAR6EUBs9iJPu7MSQGzO6jnshgAEIACBLgQQm12w0+jEBBCbEzsP0yEAAQhAoD0BxGZ75rQ4NwHE5tz+w3oIQAACEGhMALHZGDjNTU/g/MlKJz59XxWavqN0AAIQgAAEIKBBALGpQZE6IAABCEAAAhCAAAS8BBCbBAYEIAABCEAAAhCAgBkBxKYZWiqGAAQgAAEIQAACEEBsEgMQgAAEIAABCEAAAmYEEJtmaKkYAhCAAAQgAAEIQACxSQxAAAIQgAAEIAABCJgRQGyaoaViCEAAAhCAAAQgAAHEJjEAAQhAAAIQgAAEIGBGALFphpaKIQABCEAAAhCAAAQQm8QABCAAAQhAAAIQgIAZAcSmGVoqhgAEIAABCEAAAhBAbBIDEIAABCAAAQhAAAJmBBCbZmipGAIQgAAEIAABCEAAsUkMQAACEIAABCAAAQiYEUBsmqGlYghAAAIQgAAEIAABxCYxAAEIQAACEIAABCBgRgCxaYaWiiEAAQhAAAIQgAAEEJvEAAQgAAEIQAACEICAGQHEphlaKoYABCAAAQhAAAIQQGwSAxCAAAQgAAEIQAACZgQQm2ZoqRgCEIAABCAAAQhAALFJDEAAAhCAAAQgAAEImBFAbJqhpWIIQAACEIAABCAAAcQmMQABCEAAAhCAAAQgYEYAsWmGloohAAEIQAACEIAABBCbxAAEIAABCEAAAhCAgBkBxKYZWiqGAAQgAAEIQAACEEBsEgMQgAAEIAABCEAAAmYEEJtmaKkYAhCAAAQgAAEIQACxSQxAAAIQgAAEIAABCJgRQGyaoaViCEAAAhCAAAQgAAHEJjEAAQhAAAIQgAAEIGBGALFphpaKIQABCEAAAhCAAAQQm8QABCAAAQhAAAIQgIAZgf8P+pdmDuIYbtUAAAAASUVORK5CYII=",
            }
        },
        watch: {},
        created() {
            makePersonSealImg().then((res) => {
                if (res.code !== 200) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "warning",
                    });
                } else {
                    this.base64Arr = res.data;
                }
            })
        },
        mounted() {

        },
        methods: {
            checkSealName(rule, value, callback) {
                var reg = new RegExp(
                    '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
                );
                if (!reg.test(value)) {
                    callback(new Error('签名不能包含下列任何字符:/:*?"<>|'));
                } else {
                    callback();
                }
            },
            closeTitleTop() {
                if (this.backUrl) {
                    this.$router.push(this.backUrl);
                } else {
                    this.$router.go(-1);
                }
            },
            templateHandle() {
                let imgBase64;
                if (this.filesForm.makeWay == 'system') {
                    imgBase64 = this.isSelect == 'square' ? this.base64Arr['squareImgBase64'] : this.base64Arr['rectangleImgBase64']
                } else {
                    imgBase64= this.handwritingImgBase64
                }

                const sealName = this.filesForm.sealName;
                if (!sealName) {
                    loadingInstance.close();
                    return
                }

                if (!imgBase64) {
                    this.$message({
                        showClose: true,
                        message: "您还未完成手绘签名，请先扫码绘制签名",
                        type: "warning",
                    });
                    loadingInstance.close();
                    return
                }

                let loadingInstance = Loading.service({
                    fullscreen: true,
                    lock: true,
                    background: "rgba(255,255,255,.5)",
                    customClass: "light-loading"
                });

                addPersonSeal({
                    sealName: this.filesForm.sealName,
                    sealType: this.filesForm.sealType,
                    makeWay: this.filesForm.makeWay,
                    imgBase64: imgBase64
                }).then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$tip({
                            type: "success",
                            msg: "操作成功"
                        });
                        this.closeTitleTop()
                    }
                }).finally(() =>{
                    loadingInstance.close();
                })
            },
            handleChangeMakeWay(type) {
                this.filesForm.makeWay = type
                if (type === 'handWrite') {
                    handwriteLink().then((res) => {
                        if (res.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            this.qrcodeId = res.data.handwriteQRCodeId;
                            this.qrcodeUrl = res.data.pngBase64;

                            // 轮训签字结果
                            this.pollingResult();
                        }
                    })
                }else{
                    if (this.timer) {
                        clearInterval(this.timer);
                        this.timer = null;
                        console.log("停止原有定时器完成");
                    }
                    if(this.outTimer){
                        clearTimeout(this.outTimer);
                        this.outTimer = null;
                        console.log("停止原有超时定时器完成");
                    }
                }
            },

            getHandwriteLink() {
                handwriteLink().then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.qrcodeId = res.data.handwriteQRCodeId;
                        this.qrcodeUrl = res.data.pngBase64;
                        this.qrcodeStatus = undefined;
                        // 轮训签字结果
                        this.pollingResult();
                    }
                })
            },

            chongxie() {
                this.handwriteOk = false;
                this.handwritingImgBase64 = undefined;
                this.getHandwriteLink();
            },

            shuaxinQrcode() {
                this.getHandwriteLink();
            },

            selectSignType(type) {
                this.isSelect = type
            },

            pollingResult() {
                // 如果有已有的轮询，则停止，重新创建轮询定时器
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                    console.log("停止原有定时器完成");
                }
                if(this.outTimer){
                    clearTimeout(this.outTimer);
                    this.outTimer = null;
                    console.log("停止原有超时定时器完成");
                }

                this.qrCodeOutDated = false;
                this.timer = setInterval(this.getResultHandle, 3000);
                // 五分钟后关闭此定时器，提前5s
                this.outTimer = setTimeout(() => {
                    if(this.timer){
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                    this.qrCodeOutDated = true;
                }, 1000 * 60 * 5 + 5);
            },
            getResultHandle() {
                keepAskingHandwrite({
                    handwriteQRCodeId: this.qrcodeId,
                })
                    .then((res) => {
                        if (res.code == 500) {
                            // 报错停止轮训
                            clearInterval(this.timer);
                            this.timer = null;

                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        }else if(res.code == 7003){
                            // 二维码已过期
                            this.qrcodeStatus = "expired";
                            if (this.timer) {
                                clearInterval(this.timer);
                                this.timer = null;
                                console.log("停止原有定时器完成");
                            }
                            if(this.outTimer){
                                clearTimeout(this.outTimer);
                                this.outTimer = null;
                                console.log("停止原有超时定时器完成");
                            }
                        } else {
                            if (res.data.status === "yes") {
                                if (this.timer) {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    console.log("停止原有定时器完成");
                                }
                                if(this.outTimer){
                                    clearTimeout(this.outTimer);
                                    this.outTimer = null;
                                    console.log("停止原有超时定时器完成");
                                }
                                this.handwriteOk = true;
                                this.handwritingImgBase64 = res.data.handwritingImgBase64;
                            }else if(res.data.status === "scanned"){
                                this.qrcodeStatus = "scanned";
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .contract-title-ipt.el-input--suffix {
        /deep/ .el-input__inner {
            padding-right: 70px;
            text-overflow: ellipsis;
        }
    }

    .area-title {
        .title {
            font-size: 15px;
            font-weight: 500;
            color: #313843;
        }

        .sub {
            font-size: 11px;
            font-weight: 400;
            color: #86909C;

            & + .sub {
                margin-left: 8px;
            }
        }
    }

    .padding-20 {
        padding: 20px 20px 0;
    }

    #tempcreate-layer {
        background: #F3F3F7;
        min-height: 100vh;


        /deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
        /deep/ .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before {
            content: "";
            display: none;
        }

    }

    .tempcreate-inner-layer {
        min-height: 100vh;
        background: #fff;
        position: relative;
        padding-bottom: 146px;
    }

    .tempcreate-content {
        padding-top: 54px;

        .title-top {
            height: 54px;
            font-size: 16px;
            font-weight: 500;
            color: #1D2129;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 20px;
            border-bottom: 1px solid #F2F3F5;
            background: #fff;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 9;

            .title {
                margin-left: 12px;
            }

            .el-button {
                height: 30px;
                line-height: 30px;
            }

            .el-button /deep/ span {
                display: flex;
                align-items: center;

                svg {
                    margin-right: 8px;
                }
            }
        }


        .tempcreate-upload {
            padding: 0 20px 40px;
            font-size: 0;

            .show-upload /deep/ .el-upload--picture-card {
                display: inline-flex;

            }

            .is-error /deep/ .el-upload--picture-card .upload-inner {
                border-color: #EB6069;
            }

            /deep/ .el-upload--picture-card {
                display: inline-flex;
                margin-top: 20px;
                width: auto;
                height: auto;
                cursor: default;
                border: none;

                .upload-inner {
                    width: 380px;
                    height: 60px;
                    line-height: 60px;
                    background: #FFFFFF;
                    border-radius: 6px 6px 6px 6px;
                    border: 1.5px dashed #D2D2DC;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    &:hover {
                        background: #F4F7FF;
                        border: 1.5px dashed #3F7BF9;
                        transition: all ease .2s;
                    }
                }


                .upload-tip {
                    font-size: 12px;
                    font-weight: 400;
                    color: #86909C;
                    margin-left: 8px;
                }

            }

            /deep/ .el-upload-list {
                display: inline;

                .el-upload-list__item {
                    width: 380px;
                    height: 60px;
                    background: #F7F8FA;
                    border-radius: 6px 6px 6px 6px;
                    border: none;
                    transition: all 0.3s ease;
                    margin-right: 30px;
                    margin-top: 20px;
                    margin-bottom: 0;

                    .el-loading-spinner {
                        height: 60px;
                        margin-top: -22px;

                        .circular {
                            width: 22px;
                            height: 22px;
                        }

                        .el-loading-text {
                            margin: -5px 0 0;
                            font-size: 12px;
                        }
                    }

                    .file-info-wrap {
                        padding: 0;
                        height: 60px;
                        border: 1px solid transparent;
                        border-radius: 6px;

                        .file-info-container {
                            width: calc(100% - 78px);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-left: 16px;

                        }

                        .file-info {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;

                            padding: 12px 0;
                            width: calc(100%);

                            &.not-finish {
                                width: calc(100%) !important;
                            }

                            .file-name {
                                font-size: 12px;
                                font-weight: 400;
                                color: #313843;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .file-sub-info {
                                font-size: 10px;
                                font-weight: 400;
                                color: #86909C;

                                span + span {
                                    margin-left: 16px;
                                }
                            }


                        }

                        .file-tool {
                            width: 40px;
                            display: none;
                            align-items: center;
                            justify-content: space-between;

                            span {
                                cursor: pointer;
                            }
                        }

                        &.not-finish {
                            border-color: transparent !important;;
                        }

                        &:hover {
                            border-color: #D8D8D8;

                            .file-info {
                                width: calc(100% - 56px);
                            }

                            .file-tool {
                                display: flex;
                            }
                        }
                    }

                }
            }

        }

        .tempcreate-temp {
            /deep/ .el-upload-list .el-upload-list__item {
                margin-bottom: 0;
            }
        }


        .el-form {

            .el-form-item-line {
                display: flex;
                align-items: center;
            }

            .el-form-item {
                margin-bottom: 22px;
                margin-right: 40px;
            }
        }

        /deep/ .el-tabs--border-card {
            border: none;
            box-shadow: none;

            .el-tabs__header {
                background: #f0f0f5;
            }

            .el-tabs__item {
                margin-right: 12px;
                background: #e5e5e5;
                border: none;

                &.is-active {
                    background: #fff;
                }
            }

            .el-tabs__content {
                padding: 0;
            }
        }

        .tempcreate-files {
            background: #fff;
            padding: 20px 30px 0;

            .tempcreate-title {
                padding: 1px 8px;
                font-size: 15px;
                font-weight: 400;
                color: #333333;
                border-left: 3px solid #3296fa;
            }

            .sign-uploader {
                width: 90px;
                height: 90px;
                padding: 10px;
                border: 1px solid #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;


            }

            .sign-uploader:hover {
                border-color: #3F7BF9;
            }

            .rectimg {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);

                /deep/ .el-image__preview {
                    cursor: zoom-in;
                }
            }


            .imgText {
                text-align: center;
                color: #424E66;
                font-size: 13px;
            }

            .sign-previewer {
                width: 320px;
                height: 220px;
                /*padding: 10px;*/
                border: 1px solid #dcdcdc;
                border-radius: 10px;
                position: relative;
                overflow: hidden;
            }

            .handle-sign {
                width: 760px;
                height: 350px;
                background: #F7F8FA;
                position: relative;

                .wexin {
                    position: absolute;
                    right: 0;
                    top: 0;
                }
            }

            .handWrite-previewer {
                width: 760px;
                height: 350px;
                background: #F7F8FA;
            }

            .handWrite-previewer p {
                position: absolute;
                font-size: 12px;
                font-weight: 400;
                color: #3D3D3D;
                margin-left: 40px;
                margin-top: 30px;
                width: 60px;
                height: 18px;
                line-height: 18px;
            }

            .handWrite-previewer .imgBack {
                position: absolute;
                vertical-align: middle;
                width: 320px;
                height: 220px;
                background: #FFFFFF;
                border-radius: 10px 10px 10px 10px;
                border: 1px solid #DCDCDC;
                margin-left: 220px;
                margin-top: 54px;
            }

            .handWrite-previewer .handWriteBored {
                position: absolute;
                width: 140px;
                height: 70px;
                border-radius: 8px 8px 8px 8px;
                border: 1px dashed #86909C;
                margin-top: 129px;
                margin-left: 310px;
            }

            .handWrite-previewer .handWriteImg {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .chongxie {
                position: absolute;
                margin-top: 298px;
                margin-left: 323px;
                width: 92px;
                height: 32px;
                background: #E7EDFC;
                border-radius: 4px 4px 4px 4px;

                font-size: 14px;
                font-weight: 400;
                color: #3F7BF9;
                text-align: center;
                vertical-align: middle;
            }

            .scanned{
                width: 130px;
                height: 130px;
                background: #FFFFFF;
                border-radius: 6px 6px 6px 6px;
                opacity: 0.95;
            }

        }
    }
</style>
<style>
    .el-tooltip__popper.is-dark.max220-popper {
        max-width: 220px;
        word-wrap: break-word;
        text-align: left;
    }
</style>
